/*
 * @Description:
 * @Date: 2021-10-20 11:43:02
 */
import Login from '../views/login.vue';

export const route = [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录',
      noLayout: true
    },
    component: Login
  }
];
